<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Channel Sync Details'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <!-- iCal Export Section -->
      <tidy-card>
        <tidy-row [align]="'center'" class="extra-bottom-padding">
          <tidy-image
            src="assets/svg/calendar-outline.svg"
            style="width: 48px; height: 48px; margin-right: 16px;" />
          <div style="flex: 1;">
            <tidy-text [title]="'iCal Export'" />
            <tidy-text
              [body]="'Subscribe to your schedule in any calendar app'"
              class="sync-time" />
          </div>
        </tidy-row>

        <tidy-divider />

        <tidy-row class="extra-top-padding">
          <tidy-text [body]="'Calendar URL'" style="font-weight: 600;" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="icalUrl"
            style="word-break: break-all; font-size: 11px; font-family: monospace;" />
        </tidy-row>

        <tidy-row class="extra-top-padding">
          <tidy-button
            [text]="'Copy URL'"
            class="secondary"
            [action]="copyIcalUrl.bind(this)" />
        </tidy-row>

        <tidy-row class="extra-top-padding">
          <tidy-text [body]="'How to use'" style="font-weight: 600;" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'Copy the URL above and paste it into your calendar app:'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'• Google Calendar: Settings → Add calendar → From URL'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'• Apple Calendar: File → New Calendar Subscription'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'• Outlook: Add calendar → Subscribe from web'" />
        </tidy-row>
      </tidy-card>

      @if (channels.length === 0) {
        <tidy-card>
          <tidy-row [align]="'center'">
            <tidy-text [body]="'No other channels currently synced.'" />
          </tidy-row>
        </tidy-card>
      }

      @for (channel of channels; track channel.id) {
        <tidy-card>
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-image
              [src]="channel.guest_reservation_source_type.logo_url"
              style="width: 48px; height: 48px; margin-right: 16px;" />
            <div style="flex: 1;">
              <tidy-text [title]="channel.guest_reservation_source_type.name" />
              <tidy-text
                [body]="('Last sync: ' | translate) + formatSyncTime(channel.last_sync_at)"
                class="sync-time" />
            </div>
            <div
              class="sync-status-dot"
              [style.background-color]="getSyncStatusColor(channel.state)"></div>
          </tidy-row>

          <tidy-divider />

          <tidy-row class="extra-top-padding">
            <tidy-text [body]="'Sync Status'" style="font-weight: 600;" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [helper]="('State: ' | translate) + (channel.state | titlecase)" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [helper]="('Fetch Status: ' | translate) + (channel.guest_reservation_fetch_status | titlecase)" />
          </tidy-row>

          @if (channel.address_automatic_booking_setting?.automatic_booking_enabled) {
            <tidy-row class="extra-top-padding">
              <tidy-text [body]="'Automatic Booking Enabled'" style="font-weight: 600; color: #4CAF50;" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [helper]="('Service: ' | translate) + channel.address_automatic_booking_setting.required_team_service.name" />
            </tidy-row>
          }

          @if (channel.url) {
            <tidy-row class="extra-top-padding">
              <tidy-text [body]="'Calendar URL'" style="font-weight: 600;" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [helper]="channel.url"
                style="word-break: break-all; font-size: 11px;" />
            </tidy-row>
          }
        </tidy-card>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
